<template>
	<div class="container ar">
		<breadcrumbs
			class="ar"
			:links="[
				{ name: $t('links.home'), link: { name: 'home' } },
				{ name: $t('links.rules'), link: {}, active: true },
			]"></breadcrumbs>
		<div class="top">
			<div class="title">{{ $t('links.rules') }}</div>
		</div>
		<div class="main">
			<div class="files">
				<div class="files-title fw-bold">{{ $t('rp.download.download') }}</div>
				<div class="d-flex">
					<div class="files-item">
						<span
							><img src="/assets/Icons/download.png" alt="" /><a
								href="/files/استمارة نشر بحث مسجل .pdf"
								target="_blank"
								>{{ $t('rp.download.subscribe') }}</a
							></span
						>
					</div>
					<div class="files-item">
						<span
							><img src="/assets/Icons/download.png" alt="" /><a
								href="/files/استمارة نشر بحث - غير مسجل.pdf"
								target="_blank"
								>{{ $t('rp.download.non-subscribe') }}</a
							></span
						>
					</div>
					<div class="files-item">
						<span
							><img src="/assets/Icons/download.png" alt="" /><a
								href="/files/استمارة نشر بحث _طالب دراسات عليا.pdf"
								target="_blank"
								>{{ $t('rp.download.master') }}</a
							></span
						>
					</div>
				</div>
			</div>
			<div class="first">
				<div class="sub-title">{{ $t('rp.title') }}</div>
				<ul>
					<li v-if="$t('rp.rules.1')">{{ $t('rp.rules.1') }}</li>
					<li v-if="$t('rp.rules.2')">{{ $t('rp.rules.2') }}</li>
					<li v-if="$t('rp.rules.3')">{{ $t('rp.rules.3') }}</li>
					<li v-if="$t('rp.rules.4')">{{ $t('rp.rules.4') }}</li>
					<li v-if="$t('rp.rules.5')">{{ $t('rp.rules.5') }}</li>
					<li v-if="$t('rp.rules.6')">{{ $t('rp.rules.6') }}</li>
					<li v-if="$t('rp.rules.7')">{{ $t('rp.rules.7') }}</li>
					<li v-if="$t('rp.rules.8')">{{ $t('rp.rules.8') }}</li>
					<li v-if="$t('rp.rules.9')">{{ $t('rp.rules.9') }}</li>
					<li v-if="$t('rp.rules.10')">{{ $t('rp.rules.10') }}</li>
				</ul>
			</div>
			<div class="sec">
				<div class="sub-title" @click="showSec">{{ $t('rp.how-to-write.title') }}</div>
				<div class="sec-container">
					<div class="sec-list">
						<div class="sec-item sec-item-selected" @click="changeReference(0)">
							{{ $t('rp.how-to-write.types.arabic-book') }}
						</div>
						<div class="sec-item" @click="changeReference(1)">
							{{ $t('rp.how-to-write.types.english-book') }}
						</div>
						<div class="sec-item" @click="changeReference(2)">
							{{ $t('rp.how-to-write.types.arabic-ref') }}
						</div>
						<div class="sec-item" @click="changeReference(3)">
							{{ $t('rp.how-to-write.types.english-ref') }}
						</div>
						<div class="sec-item" @click="changeReference(4)">
							{{ $t('rp.how-to-write.types.chapter') }}
						</div>
					</div>
					<div class="sec-desc">
						<p>{{}}</p>
						<p class="sec-desc-eg">{{}}</p>
					</div>
				</div>
			</div>
			<div class="third">
				<div class="sub-title" @click="showThird">{{ $t('rp.print.title') }}</div>
				<div class="page-list">
					<div class="page-item ck-content" v-html="$t('rp.print.options-1')"></div>
					<div class="page-item ck-content" v-html="$t('rp.print.options-2')"></div>
					<div class="page-item ck-content" v-html="$t('rp.print.options-3')"></div>

					<div class="page-item pi-font">
						<div class="pi-name">{{ $t('rp.print.font.title') }}</div>
						<div class="pi-main">
							<div class="table-container">
								<tr class="tc-title">
									<td>{{ $t('rp.print.font.header.paragraph') }}</td>
									<td>{{ $t('rp.print.font.header.arabic') }}</td>
									<td>{{ $t('rp.print.font.header.english') }}</td>
									<td>{{ $t('rp.print.font.header.weight') }}</td>
								</tr>
								<tr class="tc-sub-title">
									<td>{{ $t('rp.print.font.header.family') }}</td>
									<td>Simplified Arabic</td>
									<td>Times New Roman</td>
									<td></td>
								</tr>
								<tr v-for="font in fonts" :key="font">
									<td>{{ font.name }}</td>
									<td>{{ font.fsAr }}</td>
									<td>{{ font.fsEn }}</td>
									<td>{{ font.fw }}</td>
								</tr>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="fourth">
				<div class="sub-title" @click="showFourth">{{ $t('rp.word.title') }}</div>
				<div class="ck-content" v-html="$t('rp.word.description')"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumbs from '../../components/Breadcrumbs';
export default {
	components: {
		Breadcrumbs,
	},
	data() {
		return {
			fonts: [
				{
					name: this.$t('rp.print.font.types.1'),
					fsAr: '16',
					fsEn: '14',
					fw: this.$t('rp.print.font.weight.bold'),
				},
				{
					name: this.$t('rp.print.font.types.2'),
					fsAr: '13',
					fsEn: '12',
					fw: this.$t('rp.print.font.weight.bold'),
				},
				{
					name: this.$t('rp.print.font.types.3'),
					fsAr: '11',
					fsEn: '10',
					fw: this.$t('rp.print.font.weight.normal'),
				},
				{
					name: this.$t('rp.print.font.types.4'),
					fsAr: '14',
					fsEn: '12',
					fw: this.$t('rp.print.font.weight.bold'),
				},
				{
					name: this.$t('rp.print.font.types.5'),
					fsAr: '13',
					fsEn: '12',
					fw: this.$t('rp.print.font.weight.normal'),
				},
				{
					name: this.$t('rp.print.font.types.6'),
					fsAr: '14',
					fsEn: '13',
					fw: this.$t('rp.print.font.weight.bold'),
				},
				{
					name: this.$t('rp.print.font.types.7'),
					fsAr: '13',
					fsEn: '12',
					fw: this.$t('rp.print.font.weight.bold'),
				},
				{
					name: this.$t('rp.print.font.types.8'),
					fsAr: '10',
					fsEn: '10',
					fw: this.$t('rp.print.font.weight.normal'),
				},
				{
					name: this.$t('rp.print.font.types.9'),
					fsAr: '12',
					fsEn: '12',
					fw: this.$t('rp.print.font.weight.normal'),
				},
				{
					name: this.$t('rp.print.font.types.10'),
					fsAr: '13',
					fsEn: '12',
					fw: this.$t('rp.print.font.weight.normal'),
				},
				{
					name: this.$t('rp.print.font.types.11'),
					fsAr: '10',
					fsEn: '10',
					fw: this.$t('rp.print.font.weight.normal'),
				},
			],
			reference: [
				{
					main: this.$t('rp.how-to-write.arabic-book.main'),
					eg: this.$t('rp.how-to-write.arabic-book.example'),
				},
				{
					main: this.$t('rp.how-to-write.english-book.main'),
					eg: this.$t('rp.how-to-write.english-book.example'),
				},
				{
					main: this.$t('rp.how-to-write.arabic-ref.main'),
					eg: this.$t('rp.how-to-write.arabic-ref.example'),
				},
				{
					main: this.$t('rp.how-to-write.english-ref.main'),
					eg: this.$t('rp.how-to-write.english-ref.example'),
				},
				{
					main: this.$t('rp.how-to-write.chapter.main'),
					eg: this.$t('rp.how-to-write.chapter.example'),
				},
			],
			referencePara: '',
			referenceEg: '',
		};
	},
	methods: {
		showSec() {
			document.querySelector('.sec').classList.toggle('show');
		},
		showThird() {
			document.querySelector('.third').classList.toggle('show');
		},
		showFourth() {
			document.querySelector('.fourth').classList.toggle('show');
		},
		changeReference(index) {
			document.querySelector('.sec-desc p').innerHTML = this.reference[index].main;
			document.querySelector('.sec-desc-eg').innerHTML = this.reference[index].eg;
			const secList = document.querySelectorAll('.sec-item');
			secList.forEach((e) => {
				e.classList.remove('sec-item-selected');
			});
			secList[index].classList.add('sec-item-selected');
		},
	},
	mounted() {
		this.changeReference(0);
		// document
		//   .querySelector(".title")
		//   .insertAdjacentHTML("beforebegin", "<strong>asd</br>asd</strong>");
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
}
.container > * {
	margin: 0 50px;
}
.top {
	text-align: center;
	padding: 10px 0 30px;
	border-bottom: 2px solid var(--borders-color);
}
.top > * {
	padding: 10px;
}
.title {
	font-size: 36px;
	font-family: changeBold;
	color: var(--green-color);
}
.main {
	padding: 20px 0 50px 15%;
	position: relative;
}
.main > * > :nth-child(2) {
	padding: 20px 0;
}
.sub-title {
	width: 55%;
	font-size: 26px;
	font-family: changeBoldSemi;
	color: var(--green-color);
	padding: 30px 0 10px;
	border-bottom: 2px solid var(--borders-color);
}
.main > div:not(:first-child) > .sub-title::after {
	content: '';
	width: 10px;
	height: 10px;
	border-bottom: 3px solid var(--green-color);
	border-right: 3px solid var(--green-color);
	transform: rotate(45deg);
	display: inline-block;
	margin: 0 10px;
	transition: 500ms;
}
.show > .sub-title::after {
	transform: rotate(225deg) !important;
}
/* .sub-title:first-child::after {
  display: none;
} */
.first ul {
	list-style: decimal;
	list-style-position: inside;
}
.first ul li {
	font-size: 17px;
	line-height: 23px;
	padding: 7px 0;
	font-family: changeMedium;
}
.first ul li::marker {
	font-size: 20px;
	font-family: changeBold;
	color: black;
}
.sec-container {
	display: flex;
	align-items: flex-start;
}
.sec-list {
	flex: 2;
	padding-left: 50px;
}
.sec-item {
	border: 2px solid #ccc;
	border-bottom: none;
	font-size: 15px;
	line-height: 20px;
	padding: 10px 15px;
	color: #666;
	font-family: changeMedium;
}
.sec-item:last-child {
	border-bottom: 2px solid #ccc;
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
}
.sec-item:first-child {
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
}
.sec-item-selected {
	font-family: changeBold;
	color: var(--grey-color);
	background: #ccc;
}
.sec-desc {
	flex: 3;
	padding: 15px 0;
}
.sec-desc p {
	font-size: 18px;
	line-height: 27px;
	font-family: changeMedium;
}
.sec-desc .sec-desc-eg {
	font-size: 16px;
	font-family: change;
}
.page-item {
	display: flex;
	padding: 15px 0;
}
.page-item * {
	font-size: 18px;
	line-height: 26px;
	height: fit-content;
}
.table-container {
	border: 1px solid #ccc;
}
.table-container * {
	text-align: center;
	padding: 5px 10px;
	border: 1px solid #ccc;
	border-collapse: collapse;
	font-size: 16px;
}
.table-container td:first-child {
	width: 50%;
}
.tc-title * {
	font-family: changeBoldSemi;
}
.tc-sub-title * {
	font-family: changeBoldSemi;
	line-height: 20px;
}

.sec > *:nth-child(2),
.third > *:nth-child(2),
.fourth > *:nth-child(2) {
	display: none;
}
.show > *:nth-child(2) {
	display: block;
}
.show > .sec-container {
	display: flex;
}
.files {
	position: absolute;
	top: 20px;
	left: 0;
}
.files-item {
	padding: 0 10px !important;
}
.files-item img {
	height: 1.5rem;
}
@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px 50px;
	}
	.main {
		padding: 0;
	}
	.sub-title {
		width: 80%;
	}
	.files {
		position: static;
	}
}
@media only screen and (max-width: 575px) {
	.sub-title {
		width: 100%;
	}
	.sec-container {
		flex-direction: column-reverse;
	}
	.sec-list {
		padding: 0;
	}
	.page-item {
		flex-wrap: wrap;
	}
	.pi-main-item {
		flex-wrap: wrap;
		margin: 5px 0;
	}
	.pi-name {
		padding: 0;
		margin-bottom: 7px;
	}
	.pi-sub {
		padding: 0;
	}
	.pi-main {
		padding: 0 !important;
	}
}
</style>

<style>
.pi-name {
	font-family: changeBold;
	padding: 0 10px;
}
.pi-name::after {
	content: ':';
	padding: 5px;
}

.pi-main-item {
	display: flex;
}
.pi-sub {
	font-family: changeMedium;
	padding: 0 10px;
}

.pi-sub::after {
	content: ':';
	padding: 5px;
}
.pi-font {
	flex-direction: column;
	max-width: 700px;
}
.pi-font .pi-main {
	padding: 20px;
}
.fourth ul {
	list-style-position: inside;
}
.fourth ul li {
	font-size: 17px;
	line-height: 23px;
	padding: 7px 0;
	font-family: changeMedium;
}
.fourth ul li::marker {
	font-size: 20px;
	color: black;
}
</style>
